import { Component, OnInit, Output, EventEmitter, Input, Renderer2, OnDestroy, inject } from '@angular/core';
import { ActivityRecord } from '@components/activity-record/activity-record';
import { AlbumService } from '@components/album/album.service';
import { merge } from 'lodash';

@Component({
  selector: 'app-album-select-activity-modal',
  templateUrl: './album-select-activity-modal.component.html',
  styleUrls: ['./album-select-activity-modal.component.scss'],
  standalone: false,
})
export class AlbumSelectActivityModalComponent implements OnInit, OnDestroy {
  private renderer = inject(Renderer2);
  private albumService = inject(AlbumService);

  @Output() eventSelectActivityModal = new EventEmitter<boolean>();
  @Output() eventShowActivity = new EventEmitter<number>();
  @Input() albumId: number;
  activitiesLoaded = false;
  isLoading = false;
  activities: Array<ActivityRecord>;
  errMsg: string;
  isShowFilter = false;
  filterStatus = 'none';
  nextPage = null;
  total_records = 0;
  searchParams = {};

  ngOnInit() {
    this.renderer.addClass(document.body, 'modal-open');
    this.getActivities(this.defaultParams());
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'modal-open');
  }

  async doFilter(params = {}) {
    if (!this.isShowFilter) {
      return false;
    }
    if (this.filterStatus === 'processing' || this.filterStatus === 'wait') {
      this.filterStatus = 'wait';
      return true;
    }
    this.filterStatus = 'processing';
    Object.assign(params, this.defaultParams());

    this.searchParams = params;
    this.albumService.getAlbumActivities(params).subscribe(
      (response) => {
        this.activities = response['activity_records'];
        this.nextPage = response['next_page'];
        this.total_records = response['total_records'];
        if (this.filterStatus === 'wait') {
          this.filterStatus = 'none';
          this.doFilter();
        } else {
          this.filterStatus = 'none';
        }
      },
      (error) => {
        this.filterStatus = 'none';
      },
    );
  }

  closeFilter() {
    this.isShowFilter = false;
    this.getActivities(this.defaultParams());
  }

  getActivities(params: {}) {
    this.albumService.getAlbumActivities(params).subscribe(
      (response) => {
        this.activities = response['activity_records'];
        this.nextPage = response.next_page;
        this.total_records = response['total_records'];
        this.activitiesLoaded = true;
      },
      (error) => {
        this.errMsg = <any>error;
      },
    );
  }

  onLoadMore() {
    if (this.isLoading || !this.nextPage) {
      return;
    }
    this.isLoading = true;
    this.albumService.getAlbumActivities(merge(this.searchParams, { page: this.nextPage })).subscribe(
      (response) => {
        this.activities.push(...response['activity_records']);
        this.nextPage = response['next_page'];
        this.total_records = response['total_records'];
        this.isLoading = false;
      },
      (error) => {
        this.errMsg = <any>error;
      },
    );
  }

  showFilter() {
    this.isShowFilter = true;
  }

  closeSelectActivityModal() {
    this.eventSelectActivityModal.emit(false);
  }

  dataLoaded() {
    return this.activitiesLoaded;
  }

  handleClickActivity(activityRecord: ActivityRecord) {
    this.eventShowActivity.emit(activityRecord.id);
  }

  private defaultParams() {
    return { not_album_id: this.albumId };
  }
}
